import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const Check = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
  </IconSvg>
);

export default Check;
